<template>
  <Nav />
  <div class="not-found-container">
    <div class="not-found-content">
      <h2 class="error-title">페이지를 찾을 수 없습니다</h2>
      <p class="error-message">
        요청하신 페이지가 존재하지 않거나 이동되었을 수 있습니다.
      </p>
      <div class="action-buttons">
        <button @click="goHome" class="btn-home">홈으로</button>
        <button @click="goBack" class="btn-back">이전 페이지</button>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script setup>
import { useRouter } from "vue-router";
import Nav from "@/components/new/Nav.vue";
import Footer from "@/components/new/Footer.vue";

const router = useRouter();

/**
 * 홈페이지로 이동
 */
const goHome = () => {
  router.push("/");
};

/**
 * 이전 페이지로 이동
 */
const goBack = () => {
  router.go(-1);
};
</script>

<style scoped>
.not-found-container {
  min-height: calc(100vh - var(--nav-height, 80px));
  margin-top: var(--nav-height, 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding: 20px;
}

.not-found-content {
  text-align: center;
  max-width: 500px;
}

.error-exc {
  font-size: 8rem;
  font-weight: bold;
  color: #727272;
  margin: 0;
  line-height: 1;
}

.error-title {
  font-size: 2rem;
  color: #333;
  margin: 1rem 0;
  font-weight: 600;
}

.error-message {
  font-size: 1.1rem;
  color: #727272;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.action-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-home,
.btn-back {
  padding: 12px 24px;
  border: none;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}

.btn-home {
  background-color: #007bff;
  color: white;
}

.btn-home:hover {
  background-color: #0056b3;
  transform: translateY(-2px);
}

.btn-back {
  background-color: #727272;
  color: white;
}

.btn-back:hover {
  background-color: #545b62;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .error-exc {
    font-size: 6rem;
  }

  .error-title {
    font-size: 1.5rem;
  }

  .action-buttons {
    flex-direction: column;
    align-items: center;
  }

  .btn-home,
  .btn-back {
    width: 200px;
  }
}
</style>
